import type React from "react"
import { Button, Form, Space, type FormInstance } from "antd"
import type { FilterConfig, FilterValues } from "types"
import FilterInput from "./FiltreInputSFS"
import { SearchOutlined } from "@ant-design/icons"
import GetLabel from "DisplayFramework/components/GetLabel"

export interface FilterBarProps {
  form: FormInstance
  subtitle?: string
  filters: FilterConfig[]
  onSearch: (values: FilterValues) => void
  onReset: () => void
  hiddenSearch?: boolean
  hiddenReset?: boolean
}

const Filter: React.FC<FilterBarProps> = ({
  form,
  subtitle,
  filters,
  onSearch,
  onReset,
  hiddenSearch = false,
  hiddenReset = false,
}) => {
  const handleReset = () => {
    form.resetFields()
    onReset()
  }

  const handleSearch = () => {
    const values = form.getFieldsValue()
    console.log("handleSearch", values)
    onSearch(values)
  }

  const handleFieldChange = () => {
    const values = form.getFieldsValue()
    onSearch(values)
  }

  return (
    <Form form={form} onValuesChange={handleFieldChange}>
      <Space.Compact style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex", flex: 1, gap: "12px", flexWrap: "nowrap", minWidth: 0 }}>
          {filters.map((filter) => (
            <div
              key={filter.key}
              style={{
                flex: `1 1 ${Math.floor(100 / filters.length)}%`,
                minWidth: "120px",
              }}
            >
              <FilterInput config={filter} />
            </div>
          ))}
        </div>

        <Space style={{ marginLeft: "16px", flexShrink: 0 }}>
          <Button
            onClick={handleReset}
            className="btn-light no-border-radius ut-submit-btn filter-btn-reset"
            style={{ display: hiddenReset ? "none" : "inline-flex" }}
          >
            <GetLabel label="reset" />
          </Button>

          <Button
            type="primary"
            onClick={handleSearch}
            className="ant-btn-primary no-border-radius ut-submit-btn filter-btn-search"
            icon={<SearchOutlined />}
            style={{ display: hiddenSearch ? "none" : "inline-flex" }}
          >
            <GetLabel label="search" />
          </Button>
        </Space>
      </Space.Compact>
    </Form>
  )
}

export default Filter
